import { render, staticRenderFns } from "./AppAdditionalEduDirs.vue?vue&type=template&id=36f277ea"
import script from "./AppAdditionalEduDirs.vue?vue&type=script&lang=js"
export * from "./AppAdditionalEduDirs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports